import {
    Cheque, DadosRelCheque, DadosRelChequeEstorno, LanctoChequeAttributes, 
    LanctoContaPag, ParamsEstCheque, ParamsLiqCheque,ParamsSaveCheque, RetAPI, error99
} from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const ControleChequesService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Cheque/Attributes', 'get', { id })
        const attributes: LanctoChequeAttributes = {
            bancos: [],
            clientes: [],
            cheque: {
                id: 0,
                tipo_cheque: '',
                data_lancamento: '',
                id_banco: 0,
                agencia: 0,
                agencia_digito: '',
                conta: 0,
                conta_digito: '',
                numero: '',
                valor: 0,
                id_cliente: 0,
                nome_terceiro: '',
                dt_bom_para: '',
                observacao: '',
                status: '',
            }
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.bancos) {

                    resp.data.bancos.map((item: any) => {
                        attributes.bancos.push({
                            id: item.cod_banco,
                            description: item.nome,
                        })
                    })

                }

                if (resp.data.clientes) {

                    resp.data.clientes.map((item: any) => {
                        attributes.clientes.push({
                            id: item.id,
                            description: item.nome,
                        })
                    })

                }

                if (resp.data.cheque) {

                    attributes.cheque.id = resp.data.cheque.id
                    attributes.cheque.tipo_cheque = resp.data.cheque.tipo_cheque
                    attributes.cheque.nome_terceiro = resp.data.cheque.nome_terceiro
                    attributes.cheque.id_banco = resp.data.cheque.id_banco
                    attributes.cheque.conta = resp.data.cheque.conta
                    attributes.cheque.conta_digito = resp.data.cheque.conta_digito
                    attributes.cheque.data_lancamento = resp.data.cheque.data_lancamento
                    attributes.cheque.dt_bom_para = resp.data.cheque.dt_bom_para
                    attributes.cheque.agencia = resp.data.cheque.agencia
                    attributes.cheque.agencia_digito = resp.data.cheque.agencia_digito
                    attributes.cheque.numero = resp.data.cheque.numero
                    attributes.cheque.valor = resp.data.cheque.valor
                    attributes.cheque.status = resp.data.cheque.status
                    attributes.cheque.id_cliente = resp.data.cheque.id_cliente
                    attributes.cheque.observacao = resp.data.cheque.observacao

                    attributes.cheque.id_user_insert = resp.data.cheque.id_user_insert
                    attributes.cheque.id_user_last_update = resp.data.cheque.id_user_last_update
                    attributes.cheque.id_user_delete = resp.data.cheque.id_user_delete
                    attributes.cheque.dt_cadastro = resp.data.cheque.dt_cadastro
                    attributes.cheque.dt_last_update = resp.data.cheque.dt_last_update
                    attributes.cheque.dh_delete = resp.data.cheque.dh_delete
                    attributes.cheque.name_user_insert = resp.data.cheque.name_user_insert
                    attributes.cheque.name_user_last_update = resp.data.cheque.name_user_last_update
                    attributes.cheque.name_user_delete = resp.data.cheque.name_user_delete

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }
    },

    Save: async (lanctoCheques: ParamsSaveCheque): Promise<RetAPI> => {

        let id = ''

        if (lanctoCheques.id) {
            id = lanctoCheques.id.toString()
        }

        const resp = await Api('Cheque/Save', 'post', {

            tipo_cheque: lanctoCheques.tipo_cheque,
            nome_terceiro: lanctoCheques.nome_terceiro,
            id_banco: lanctoCheques.id_banco,
            conta: lanctoCheques.conta,
            conta_digito: lanctoCheques.conta_digito,
            data_lancamento: lanctoCheques.data_lancamento,
            dt_bom_para: lanctoCheques.dt_bom_para,
            agencia: lanctoCheques.agencia,
            agencia_digito: lanctoCheques.agencia_digito,
            numero: lanctoCheques.numero,
            valor: lanctoCheques.valor,
            status: lanctoCheques.status,
            id_cliente: lanctoCheques.id_cliente,
            observacao: lanctoCheques.observacao,
            id
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: 'Dados do cheque gravados com sucesso',
                id: resp.data.cheque.id,
                data: resp.data,
                dt_cadastro: resp.data.cheque.dt_cadastro,
                dt_last_update: resp.data.cheque.dt_last_update,
                name_user_insert: resp.data.cheque.name_user_insert,
                name_user_last_update: resp.data.cheque.name_user_last_update

            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Cheque/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (filterCheque?: any): Promise<RetAPI> => {

        const resp = await Api('Cheque/Filter', 'get', {
            datai: filterCheque?.datai,
            dataf: filterCheque?.dataf,
            filtrar_data_por: filterCheque?.filtrar_data_por,
            status: filterCheque?.status,
            id_cliente: filterCheque?.id_cliente,
            id_banco: filterCheque?.id_banco,
            numero: filterCheque?.numero
        })

        let dadosRel: DadosRelCheque = { cheque: [], qtdCheque: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosRel
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                dadosRel.qtdCheque = resp.data.quantidade_total
                dadosRel.total = resp.data.valor_total

                await resp.data.cheques.map((item: any) =>
                    dadosRel.cheque.push({
                        id: item.id,
                        data_lancamento: item.data_lancamento,
                        id_banco: item.id_banco,
                        agencia: item.agencia,
                        agencia_digito: item.agencia_digito,
                        conta: item.conta,
                        conta_digito: item.conta_digito,
                        numero: item.numero,
                        valor: item.valor,
                        id_cliente: item.id_cliente,
                        nome_terceiro: item.nome_terceiro,
                        data_baixa: item.data_baixa,
                        id_user_baixa: item.id_user_baixa,
                        status: item.status,
                        dt_representado: item.dt_representado,
                        tipo_cheque: item.tipo_cheque,
                        dt_bom_para: item.dt_bom_para,
                        destino_cheque: item.destino_cheque,
                        observacao: item.observacao,
                        id_user_insert: item.id_user_insert,
                        dt_cadastro: item.dt_cadastro,
                        id_user_last_update: item.id_user_last_update,
                        dt_last_update: item.dt_last_update,
                        dt_devolvido: item.dt_devolvido,
                        nome_cliente: item.nome_cliente,
                        nome_banco: item.nome_banco
                    })
                )
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosRel
            }
        }

        return {
            error: false,
            data: dadosRel
        }
    },

    FilterBordero: async (filterCheque?: any): Promise<RetAPI> => {

        const resp = await Api('Cheque/Filter/Bordero', 'get', {
            datai: filterCheque?.datai,
            dataf: filterCheque?.dataf,
            filtrar_data_por: filterCheque?.filtrar_data_por,
            status: filterCheque?.status,
            id_cliente: filterCheque?.id_cliente,
            id_banco: filterCheque?.id_banco,
            numero: filterCheque?.numero,
            bordero: filterCheque?.bordero
        })

        const dadosBordero: DadosRelChequeEstorno = { chequeEstorno: [], qtdCheque: 0, total: 0 }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosBordero
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                dadosBordero.qtdCheque = resp.data.quantidade_total
                dadosBordero.total = resp.data.valor_total

                resp.data.cheques.map((item: any) => {
                    return dadosBordero.chequeEstorno.push({
                        data_baixa: item.data_baixa,
                        observacao: item.obs_baixa,
                        valor: item.valor,
                        id_bordero: item.id_bordero,
                        qtd: item.qtd,
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosBordero
            }
        }

        return {
            error: false,
            data: dadosBordero
        }

    },

    FilterExcluidas: async (filterCheque?: any): Promise<RetAPI> => {

        const resp = await Api('Cheque/Filter/Excluidas', 'get', {
            datai: filterCheque?.datai,
            dataf: filterCheque?.dataf,
            nome_cliente: filterCheque?.nome_cliente,
        })

        let dadosExcluidas: Cheque[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dadosExcluidas
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                await resp.data.cheques.map((item: any) =>
                    dadosExcluidas.push({
                        id: item.id,
                        id_banco: item.id_banco,
                        id_cliente: item.id_cliente,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_delete: item.id_user_delete,
                        id_user_baixa: item.id_user_baixa,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_delete: item.dh_delete,
                        data_baixa: item.data_baixa,
                        data_lancamento: item.data_lancamento,
                        dt_bom_para: item.dt_bom_para,
                        dt_representado: item.dt_representado,
                        dt_devolvido: item.dt_devolvido,
                        tipo_cheque: item.tipo_cheque,
                        agencia: item.agencia,
                        agencia_digito: item.agencia_digito,
                        conta: item.conta,
                        conta_digito: item.conta_digito,
                        numero: item.numero,
                        valor: item.valor,
                        nome_terceiro: item.nome_terceiro,
                        observacao: item.observacao,
                        status: item.status,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete,
                        destino_cheque: item.destino_cheque,
                        nome_cliente: item.nome_cliente,
                        nome_banco: item.nome_banco,
                        motivo_delete: item.motivo_delete
                    })
                )
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dadosExcluidas
            }
        }

        return {
            error: false,
            data: dadosExcluidas
        }
    },

    LiquidarCheques: async (params: ParamsLiqCheque): Promise<RetAPI> => {

        const random = uuid()

        params.senha_usuario = base64_encode(params.senha_usuario + '-' + random)

        const resp = await Api('Cheque/Liquidar', 'put', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    EstornarCheques: async (params: ParamsEstCheque): Promise<RetAPI> => {

        const random = uuid()

        params.senha_usuario = base64_encode(params.senha_usuario + '-' + random)

        const resp = await Api('Cheque/Estornar', 'put', params)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || ''
                }
            }

            return {
                error: false,
                msg: ''
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    BuscarPagamentos: async (bordero: number[]): Promise<RetAPI> => {

        const resp = await Api(`Cheque/DadosPag?bordero=${bordero}`, 'get',)
        const dados: LanctoContaPag[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: dados
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.pagCheque.map((item: any) => {
                    return dados.push({
                        description: item.descricao,
                        id_conta: item.id_conta,
                        valor: item.valor,
                    })
                })
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: dados
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: dados,
        }

    },

}
